import React, { useContext } from 'react';
const SurveyContext = React.createContext(null);

export default SurveyContext;

export function useSurveyContext() {
    return useContext(SurveyContext);
}
